// Shared SurveyJS theme variables, used by both creator and runtime
export const surveyThemeVariables = {
  "--ctr-menu-toolbar-button-icon-color": "#3f7fbf",
  "--ctr-menu-toolbar-button-icon-color-selected": "#3f7fbf",
  "--ctr-menu-toolbar-button-background-color-selected": "#cfe0e8",
  "--ctr-menu-toolbar-button-background-color-hovered": "#dbe6ec",
  "--ctr-menu-toolbar-button-text-color": "#2f3e46",
  "--ctr-menu-toolbar-button-text-color-selected": "#2f3e46",
  "--ctr-toolbox-background-color": "#cfe0e8",
  "--ctr-toolbox-border-color": "#3f7fbf",
  "--ctr-toolbox-item-icon-color": "#3f7fbf",
  "--ctr-toolbox-item-text-color": "#2f3e46",
  "--ctr-toolbox-item-icon-color-hovered": "#3f7fbf",
  "--ctr-toolbox-item-text-color-hovered": "#2f3e46",
  "--ctr-editor-background-color": "#dbe6ec",
  "--ctr-editor-border-color": "#3f7fbf",
  "--ctr-surface-background-color": "#cfe0e8",
  "--ctr-button-group-background-color": "#dbe6ec",
  "--ctr-button-group-border-color": "#3f7fbf",
  "--ctr-button-group-item-background-color": "#dbe6ec",
  "--ctr-button-group-item-background-color-hovered": "#cfe0e8",
  "--ctr-button-group-item-background-color-selected": "#3c5f2a",
  "--ctr-button-group-item-text-color": "#2f3e46",
  "--ctr-button-group-item-icon-color": "#3f7fbf",
  "--ctr-button-group-item-icon-color-selected": "#ffffff",
  "--ctr-button-group-item-border-color": "#3f7fbf",
  "--ctr-actionbar-button-icon-color": "#3f7fbf",
  "--ctr-actionbar-button-icon-color-hovered": "#3f7fbf",
  "--ctr-menu-toolbar-button-corner-radius": "12px",
  "--ctr-toolbox-search-corner-radius": "12px",
  "--ctr-button-group-item-corner-radius": "12px",
  "--ctr-button-corner-radius": "12px",
};

